import useClubStaffEditForm from './UseClubStaffEditForm';

import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import OrgRoleStaffRoleTreeView from '@usas/ui-web/components/tree/orgRoleTree/OrgRoleStaffRoleTreeView';

import { formatPhoneNumber } from '@usas/ui-web/utils/validation';
import { formatMultipleValuesForDisplay } from '@usas/ui-web/components/table/utils/TableUtils';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const ClubStaffEditForm = ({ clubStaffObj, submitButtonText = 'Save', secondaryButtonText = 'Cancel',
  staffRoleGroupId, onSubmitFormCallback, onSecondaryButtonClicked,
  onIsDirtyChanged = undefined, onErrorCaught = undefined }) => {
  const {
    isDirty,
    formState,
    errorState,
    handleSubmit,
    onPersonOrgRoleChanged,
    onValueTextPairChanged,
    coachTypeCodeOptions
  } = useClubStaffEditForm(clubStaffObj, onSubmitFormCallback, onIsDirtyChanged, onErrorCaught);

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <ReadOnly
            label="Member Name (Member Id)"
            name="memberName"
            value={`${clubStaffObj.firstName} ${clubStaffObj.lastName} (${clubStaffObj.memberId})`} />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <ReadOnly
            label="Phone Number"
            name="phoneNumber"
            value={formatPhoneNumber(clubStaffObj.phoneNumber)} />
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <ReadOnly
            label="Email"
            name="email"
            value={clubStaffObj.email} />
        </div>
        {formState.registrationRoles.length > 0 &&
          <div className="col-xs-12">
            <ReadOnly
              label={'Registration Role(s)'}
              name={'registrationRoles'}
              value={formatMultipleValuesForDisplay(formState.registrationRoles, 'name')} />
          </div>
        }
      </div>
      <div className='row usas-extra-top-margin usas-extra-bottom-margin'>
        <div className="col-xs-12 col-sm-6 col-md-8">
          {staffRoleGroupId &&
            <OrgRoleStaffRoleTreeView
              label="Staff Role(s)"
              name="personOrgRole"
              value={formState.personOrgRole}
              error={errorState.personOrgRole}
              message={errorState.personOrgRole}
              roleGroupId={staffRoleGroupId}
              singleSelect={false}
              selectableLeavesOnly={true}
              excludeRegistrationRolesWithoutChildren={true}
              onChange={(newValue) => { onPersonOrgRoleChanged(newValue); }} />
          }
        </div>
        {formState.hasCoachRole === true &&
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label="Full Time / Part Time Coach*"
              name="coachTypeCode"
              value={formState.coachTypeCode}
              error={errorState.coachTypeCode}
              message={errorState.coachTypeCode}
              options={coachTypeCodeOptions}
              onChange={(newValue, newValueLabel, e) => { e?.target?.value && onValueTextPairChanged(newValue, 'coachTypeCode', newValueLabel, 'coachTypeCodeName'); }} />
          </div>
        }
      </div>
      {errorState.errorOnSubmitAction &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction || ''}</p>
          </div>
        </div>
      }
      {errorState.formError &&
        <div className="row">
          <div className="col-xs-12">
            <p className={global.ErrorMessage}>{errorState.formError || ''}</p>
          </div>
        </div>
      }
      <div className="row usas-extra-top-margin usas-extra-bottom-margin">
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="submit" isDisabled={isDirty === false}>{submitButtonText}</PrimaryButton>&nbsp;
          <SecondaryButton type="button" onClick={onSecondaryButtonClicked}>{secondaryButtonText}</SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default ClubStaffEditForm;